import { types } from 'mobx-state-tree';
import { Shape } from './shape-model';

export const LineElement = Shape.named('LineElement')
  .props({
    type: types.optional(types.string, 'line'),
    color: types.optional(types.string, '#000000'),
    dash: types.optional(types.array(types.number), []),
    startHead: types.optional(types.string, ''),
    endHead: types.optional(types.string, ''),
  });
